module.exports = __webpack_public_path__ + "media/images/BowKids-13a303d7606fcc3a3e11b740a2eb90a4.jpg";